module.exports = __webpack_public_path__ + "3116e5995d1b0969c157d132ab8b402f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/calendar.svg
// module id = 443
// module chunks = 0